import { healthSourceLabel } from "./healthPresentation"

export const BODY_METRICS = [
  { key: "weightKilograms", label: "Gewicht", unit: "kg", max: 1000, exportKey: "weight" },
  { key: "muscleMassKilograms", label: "Muskelmasse", unit: "kg", max: 1000 },
  { key: "bodyFatPercentage", label: "Körperfett", unit: "%", max: 100, exportKey: "bodyFat" },
  { key: "bodyWaterKilograms", label: "Körperwasser", unit: "kg", max: 1000, exportKey: "bodyWater" },
  { key: "fatMassKilograms", label: "Fettmasse", unit: "kg", max: 1000 },
  { key: "muscleProteinKilograms", label: "Muskelprotein", unit: "kg", max: 1000 },
  { key: "visceralFatKilograms", label: "Viszerales Fett", unit: "kg", max: 1000, zero: true },
  { key: "intracellularWaterKilograms", label: "Wasser in den Zellen", unit: "kg", max: 1000 },
  { key: "extracellularWaterKilograms", label: "Wasser ausserhalb der Zellen", unit: "kg", max: 1000 },
  { key: "phaseAngleDegrees", label: "Phasenwinkel", unit: "°", max: 90 },
  { key: "bioAgeYears", label: "Bio Age", unit: "Jahre", max: 150 },
  { key: "readinessPercentage", label: "MeScan-Trainingsbereitschaft", unit: "%", max: 100, zero: true },
  { key: "heartRate", label: "Puls beim Scan", unit: "BPM", max: 300 },
  { key: "oxygenSaturationPercentage", label: "Sauerstoffsättigung", unit: "%", max: 100, exportKey: "oxygen" },
  { key: "leanMassKilograms", label: "Fettfreie Masse", unit: "kg", max: 1000 },
  { key: "boneMassKilograms", label: "Knochenmasse", unit: "kg", max: 1000 },
  { key: "basalKilocaloriesPerDay", label: "Grundumsatz", unit: "kcal/Tag", max: 10000 },
  { key: "restingHeartRate", label: "Ruhepuls", unit: "BPM", max: 300 },
  { key: "hrvRmssdMillis", label: "HRV · RMSSD", unit: "ms", max: 200, zero: true },
]
export const BODY_PARTS = [
  { key: "trunk", label: "Rumpf" }, { key: "rightArm", label: "Rechter Arm" }, { key: "leftArm", label: "Linker Arm" },
  { key: "rightLeg", label: "Rechtes Bein" }, { key: "leftLeg", label: "Linkes Bein" },
]
export const MESCAN_RATING_COLORS = ["#ff4d4d", "#ff6666", "#ff9966", "#ffd900", "#66cc66", "#72ab75", "#3c8c40"]
export const MESCAN_RATED_METRICS = ["muscleMassKilograms", "bodyFatPercentage", "fatMassKilograms", "bodyWaterKilograms", "visceralFatKilograms", "phaseAngleDegrees", "bioAgeYears", "readinessPercentage", "heartRate", "oxygenSaturationPercentage"]
export function meScanRating(key, index) {
  const colors = ["bioAgeYears", "oxygenSaturationPercentage"].includes(key)
    ? [MESCAN_RATING_COLORS[0], MESCAN_RATING_COLORS[3], MESCAN_RATING_COLORS[6]] : MESCAN_RATING_COLORS
  const valid = Number.isInteger(index) && index >= 0 && index < colors.length
  return { index: valid ? index : null, colors, color: valid ? colors[index] : "#81868b",
    label: valid ? `MeScan ${index + 1}/${colors.length}` : "Ohne Bewertung" }
}
export const MESCAN_EXPORT_TYPES = BODY_METRICS.filter(item => item.exportKey)
export const BODY_READ_TYPES = [
  { key: "bodyFat", label: "Körperfett" }, { key: "bodyWater", label: "Körperwasser" },
  { key: "leanMass", label: "Fettfreie Masse" }, { key: "boneMass", label: "Knochenmasse" },
  { key: "basalRate", label: "Grundumsatz" }, { key: "oxygen", label: "Sauerstoffsättigung" },
  { key: "restingHeartRate", label: "Ruhepuls" }, { key: "hrv", label: "Herzratenvariabilität (RMSSD)" },
]

export function bodyValue(key, value) {
  if (typeof value !== "number" || !Number.isFinite(value)) return "–"
  return value.toLocaleString("de-CH", { maximumFractionDigits: ["heartRate", "restingHeartRate", "basalKilocaloriesPerDay"].includes(key) ? 0 : 1 })
}
const valid = (metric, value) => typeof value === "number" && Number.isFinite(value) && value <= metric.max && (metric.zero ? value >= 0 : value > 0)
export function parseMeScans(raw, now = Date.now()) {
  if (!raw || !Array.isArray(raw.scans)) throw new Error("Die MeScan-Messungen konnten nicht gelesen werden.")
  const seen = new Set()
  return raw.scans.slice(0, 500).filter(scan => {
    if (!/^[a-f0-9]{64}$/.test(scan?.id) || seen.has(scan.id) || scan.source !== "mescan" || !Number.isFinite(scan.time) || scan.time < Date.UTC(2000, 0, 1) || scan.time > now) return false
    seen.add(scan.id); return true
  }).map(scan => ({ id: scan.id, time: scan.time, source: "mescan", sourceName: "MeScan", ambiguous: scan.ambiguous === true,
    values: Object.fromEntries(BODY_METRICS.filter(m => valid(m, scan.values?.[m.key])).map(m => [m.key, scan.values[m.key]])),
    segments: Object.fromEntries(BODY_PARTS.filter(p => valid({ max: 1000 }, scan.segments?.[p.key])).map(p => [p.key, scan.segments[p.key]])),
    ratings: Object.fromEntries(MESCAN_RATED_METRICS.filter(key => !scan.ambiguous && valid(BODY_METRICS.find(m => m.key === key), scan.values?.[key]) && meScanRating(key, scan.ratings?.[key]).index !== null).map(key => [key, scan.ratings[key]])),
    segmentRatings: Object.fromEntries(BODY_PARTS.filter(p => !scan.ambiguous && valid({ max: 1000 }, scan.segments?.[p.key]) && meScanRating("muscleMassKilograms", scan.segmentRatings?.[p.key]).index !== null).map(p => [p.key, scan.segmentRatings[p.key]])),
  })).sort((a, b) => b.time - a.time)
}

export function parseBodyRecords(raw, now = Date.now()) {
  if (!raw || !Array.isArray(raw.records)) throw new Error("Die Körperwerte konnten nicht gelesen werden.")
  const seen = new Set()
  return raw.records.filter(item => {
    const metric = BODY_METRICS.find(m => m.key === item?.metric)
    const id = `${item?.metric}:${item?.id}`
    if (!metric || !item.id || typeof item.id !== "string" || item.id.length > 300 || seen.has(id) || !valid(metric, item.value) || !Number.isFinite(item.time) || item.time > now || item.time < Date.UTC(2000, 0, 1)) return false
    if (!item.source || item.source === "ch.wellcomefit.roody" || item.ownExport === true) return false
    seen.add(id); return true
  }).slice(0, 20000).map(item => {
    const source = String(item.source).slice(0, 180), device = String(item.device || "").slice(0, 120)
    return { id: item.id, time: item.time, metric: item.metric, value: item.value, source, device,
      sourceName: healthSourceLabel(item), series: JSON.stringify([source, device]) }
  }).sort((a, b) => a.time - b.time)
}

export function scanDelta(current, previous, key) {
  if (!current || !previous || current.source !== "mescan" || previous.source !== "mescan" || current.id === previous.id || current.time <= previous.time || current.ambiguous || previous.ambiguous) return null
  const a = current.values[key], b = previous.values[key]
  return Number.isFinite(a) && Number.isFinite(b) ? a - b : null
}

export function bodyChart(points) {
  const sorted = points.filter(p => Number.isFinite(p.time) && Number.isFinite(p.value)).sort((a, b) => a.time - b.time)
  if (!sorted.length) return { dots: [], line: "", first: null, last: null }
  const from = sorted[0].time, to = sorted[sorted.length - 1].time
  const low = Math.min(...sorted.map(p => p.value)), high = Math.max(...sorted.map(p => p.value))
  const padding = Math.max((high - low) * .15, 1)
  const dots = sorted.map(p => ({ ...p, x: to === from ? 160 : 12 + (p.time - from) / (to - from) * 296,
    y: 132 - (p.value - low + padding) / (high - low + padding * 2) * 108 }))
  return { dots, line: dots.map(p => `${p.x.toFixed(2)},${p.y.toFixed(2)}`).join(" "), first: sorted[0], last: sorted[sorted.length - 1] }
}

// Only the four explicit mappings. No lean-mass approximation, stress/HRV
// conversion, pulse-as-resting-pulse, hydration or imported Health records.
export function meScanExportPayload(scans, selected) {
  const types = MESCAN_EXPORT_TYPES.filter(m => selected.includes(m.exportKey))
  return scans.filter(scan => scan.source === "mescan" && !scan.ambiguous).map(scan => ({
    id: scan.id, time: scan.time, source: "mescan",
    values: Object.fromEntries(types.filter(m => valid(m, scan.values[m.key])).map(m => [m.key, scan.values[m.key]])),
  })).filter(scan => Object.keys(scan.values).length)
}
